import { HttpClient } from "@angular/common/http";
import { WebApiService } from "../WebApiService";
import { httpOptionsDefault } from "../../_shared/constants";
import { catchError, map } from "rxjs";
import { Bet } from "../../_shared/models/bet.model";
import { LotteryTask } from "../../_shared/models/task.model";
import { LotteryDrawTask, TaskQueue } from "../../_shared/models/task-queue.model";
import { debug } from "console";

export class TasksController {


  constructor(public _http: HttpClient, private _webApi: WebApiService) {
  }

  addBet(bet: Bet): Promise<string> {

    return this._http.post(this._webApi.GetApiAddress() + `/tasks/addBet`, bet, httpOptionsDefault)
      .pipe(
        map(result => {
   
          if (result["success"] === false) {
            return null;
          }
          return result["bet"];
        }),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });

  }


  addLotteryTask(task: LotteryTask): Promise<TaskQueue> {


    return this._http.post(this._webApi.GetApiAddress() + `/tasks/addLotteryTask`, task, httpOptionsDefault)
      .pipe(
        map(result => {

          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });
  }

  addLotteryDrawnTask(task: LotteryDrawTask): Promise<TaskQueue> {

    return this._http.post(this._webApi.GetApiAddress() + `/tasks/addLotteryDrawnTask`, task, httpOptionsDefault)
      .pipe(
        map(result => {

          if (result["error"]) {
            console.error("Error adding lottery drawn task: ", result["error"]);
          }

          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });
  }

}
